import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import { Toaster } from "./components/ui/toaster";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Portfolio from "./pages/Portfolio";
import About from "./pages/About";
import Contact from "./pages/Contact";
import FAQ from "./pages/FAQ";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import AdminPortfolio from "./pages/AdminPortfolio";
import Privacy from "./pages/Privacy";
import TownPage from "./pages/TownPage";
import CommercialPainting from "./pages/CommercialPainting";
import { towns } from "./data/towns";
import JobPage from "./pages/JobPage";
import { jobs, jobPath } from "./data/jobs";
import NotFound from "./pages/NotFound";

// Everything inside the router. Exported so the build can render each page to
// plain HTML (scripts/ssr-render.js) under a StaticRouter.
export function AppContent() {
  return (
    <>
      {/* Skip to main content for keyboard users */}
      <a 
        href="#main-content" 
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:bg-cyan-600 focus:text-white focus:px-4 focus:py-2 focus:rounded-md"
      >
        Skip to main content
      </a>
      <ScrollToTop />
      <Navbar />
      <main id="main-content" className="pt-20">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/commercial-painting-kent" element={<CommercialPainting />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/admin/portfolio" element={<AdminPortfolio />} />
          <Route path="/privacy" element={<Privacy />} />
          {towns.map((t) => (
            <Route key={t.slug} path={t.path} element={<TownPage slug={t.slug} />} />
          ))}
          {jobs.map((j) => (
            <Route key={j.slug} path={jobPath(j)} element={<JobPage slug={j.slug} />} />
          ))}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <Toaster />
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
